import React from "react";
import styled from "styled-components";

const Footer = () => {
  return (
    <PageFooter>
      Copyright <span>2025</span> ©{" "}
      <a href="https://register.apegamobile.ca/">Apega</a>
    </PageFooter>
  );
};
const PageFooter = styled.p`
  text-align: center;
  font-size: 0.9rem;
  color: #666;
  a {
    color: #005696;
    text-decoration: none;
  }
`;
export default Footer;
